import * as React from "react";
import MetaData from "./metadata";

interface HeadProps {
  title: string;
  description: string;
  image: string;
  href: string;
  isNoIndex: boolean;
}

export const Head = (props: HeadProps) => {
  const { title, description, image, isNoIndex, href } = props;

 
  return (
    <>
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css?family=Inter:400,700|Roboto:400,700|Lora:400,700|Montserrat:400,700|Playfair+Display:400,700|Oswald:400,700|Merriweather:400,700|Raleway:400,700|Poppins:400,700|Bebas+Neue:400,700|Dancing+Script:400,700|Pacifico:400,700|Fira+Sans:400,700|Nunito:400,700|Source+Sans+Pro:400,700|Muli:400,700|Abril+Fatface:400,700|Quicksand:400,700|PT+Serif:400,700|Rubik:400,700&display=swap"
      />
      <MetaData 
        title={title}
        description={description}
        image={image}
        url={"https://podsqueeze.com"}
        keywords={"Podsqueeze, AI, Podcasts, Content Generation, Podcast transcription, Shownotes, Timestamps, Podcast Newsletters, Tweets, Blog Posts, Social Posts, Titles, Shownotes writer"} 
        isNoIndex={isNoIndex}
        href={href ? href : ""}
      />
    </>
  );
};